module.exports = __webpack_public_path__ + "img/ex-register.33717e66.jpg";